import { useCallback, useEffect, useRef, useState } from "react";
import { listStockArkBuy } from "../api/stockArkBuy";

/**
 * Load ARK ETF symbol count on Stock Management mount (tab label before ARK ETF is opened).
 */
export function useStockArkBuyCount({ accountId, serverUrl, stockSession }) {
  const [count, setCount] = useState(null);
  const inflightRef = useRef(null);
  const loadedAccountRef = useRef("");

  const reloadCount = useCallback(async () => {
    if (!accountId) return;
    if (inflightRef.current) return inflightRef.current;

    inflightRef.current = (async () => {
      try {
        const data = await listStockArkBuy(serverUrl, stockSession);
        setCount(data.totalMatched);
      } catch {
        setCount(0);
      } finally {
        inflightRef.current = null;
      }
    })();

    return inflightRef.current;
  }, [accountId, serverUrl, stockSession]);

  useEffect(() => {
    if (!accountId) {
      setCount(null);
      loadedAccountRef.current = "";
      return;
    }
    if (loadedAccountRef.current === accountId) return;
    loadedAccountRef.current = accountId;
    reloadCount();
  }, [accountId, reloadCount]);

  return { count, setCount, reloadCount };
}
